class TestimonialsSliderComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderInstance = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const swiperContainer = this.querySelector('.swiper');
    const slides = this.querySelectorAll('.swiper-slide');
    const slidesPerView = parseInt(this.dataset.slidesPerView) || 2.73207;
    const totalSlides = slides.length;

    if (totalSlides <= slidesPerView) {
      this.classList.add('slider-disabled');
      return;
    }

    this.initSlider(swiperContainer, slidesPerView);
  }

  initSlider(swiperContainer, slidesPerView) {
    const slides = this.querySelectorAll('.swiper-slide');
    const totalSlides = slides.length;
    
    const sliderOptions = {
      slidesPerView: 1.13065,
      spaceBetween: 8,
      loop: true,
      loopedSlides: totalSlides,
      grabCursor: true,
      freeMode: {
        enabled: true,
        sticky: false,
        momentum: true,
        momentumRatio: 1,
        momentumVelocityRatio: 1,
      },
      speed: 400,
      threshold: 2,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 8,
        },
        1024: {
          slidesPerView: slidesPerView,
          spaceBetween: 8,
        },
      },
    };
    
    this.sliderInstance = new FoxTheme.Carousel(swiperContainer, sliderOptions);
    this.sliderInstance.init();
  }

  disconnectedCallback() {
    if (this.sliderInstance && this.sliderInstance.slider) {
      this.sliderInstance.slider.destroy();
    }
  }
}

customElements.define('testimonials-slider-component', TestimonialsSliderComponent);
